var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"mb-3"},[_c('v-col',[_c('h2',{staticClass:"headline font-weight-bold",style:({ color: _vm.colors[_vm.subjectName] })},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.names[_vm.subjectName])}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }